<ng-container *ngIf="tijden">
  <div class="ols-textbox ols-textbox-tijd" [ngClass]="{'has-error': submitClicked && !tijdHadFocus}">
    <input #textBoxField type='text' name='text' (focus)='setTextFocus(true)' (blur)='setTextFocus(false)'
      [(ngModel)]="tekst" placeholder="{{placeholder}}"
      oninput="this.value=this.value.replace(/[^0-9:]/g,'')">
    <div class="icon-time ial-fu_015" (click)="toggleTime()"></div>
    <div *ngIf="timeOpen" class="ols-timecontainer">
      <ol>
        <li *ngFor="let tijd of tijden" (click)="selectTime(tijd)">{{tijd}}</li>
      </ol>
    </div>
  </div>
  <p class="error-block" *ngIf="tijdHadFocus && !validTime">{{errormessageText}}</p>
  <p class="error-block" *ngIf="tijdHadFocus && validTime && validatieErrorFuture">{{errormessageTextFuture}}</p>
  <p class="error-block" *ngIf="submitClicked && !tijdHadFocus">Kies alsjeblieft een tijd</p>
</ng-container>